import React, { useMemo } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../../../store';
import Heading from '../../../../../../generic-components/Heading';
import { STYLES } from '../../consts';

export const BillAmount = () => {
  const billData = useStore(state => state.billData);
  const setBillData = useStore(state => state.setBillData);
  const { t } = useTranslation();
  const handleInput = (strAmount: string) => {
    const intValue = Number(strAmount);
    setBillData({ ...billData, amount: intValue });
  };

  const billValue = useMemo(() => {
    if (!billData.amount) return '';
    return billData.amount.toFixed(2);
  }, [billData.amount]);

  return (
    <div className={STYLES.CREATE_BILL_BODY.BILL_AMOUNT.WRAPPER}>
      <Heading title={t('CREATE_BILL.FORM.AMOUNT')} className={STYLES.CREATE_BILL_BODY.BILL_AMOUNT.TITLE} />
      <CurrencyInput
        id='inputBillAmount'
        name='input-amount'
        maxLength={9}
        className={STYLES.CREATE_BILL_BODY.BILL_AMOUNT.CURRENCY_INPUT}
        placeholder='$0.00'
        defaultValue={billValue}
        decimalsLimit={2}
        prefix='$'
        onValueChange={(value) => handleInput(value || '0')}
      />
    </div>
  );
};
